import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NewsService } from './news.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, switchMap, tap } from 'rxjs';
import { BreadCrump } from '../../shared/bread-crump/bread-crump';
import { BrowsePaginatorComponent } from '../../features/browse-index/components/browse-paginator/browse-paginator.component';
import { PaginationState } from '../../features/browse-index/models';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, BreadCrump, BrowsePaginatorComponent, FooterComponent],
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss',
})
export class NewsComponent implements OnInit {
  private newsService = inject(NewsService);
  public translate = inject(TranslateService);

  private page$ = new BehaviorSubject<number>(1);
  private pageSize = 9;

  newsArticles: any[] = [];
  loading = signal<boolean>(false);
  pagination: PaginationState = {
    currentPage: 1,
    pageSize: 9,
    totalCount: 0,
    totalPages: 0
  };

  ngOnInit(): void {
    this.page$.pipe(
      tap(() => this.loading.set(true)),
      switchMap(page => this.newsService.getNews(page, this.pageSize))
    ).subscribe({
      next: (res) => {
        this.newsArticles = res.result || [];
        this.pagination = {
          currentPage: this.page$.value,
          pageSize: this.pageSize,
          totalCount: res.totalElements,
          totalPages: Math.ceil(res.totalElements / this.pageSize) || 0
        };
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
      }
    });
  }

  onPageChange(page: number): void {
    this.page$.next(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getFileUrl(filePath: string): string {
    if (!filePath) return '/media/images/custom/defualt-img.jpg';
    if (filePath.startsWith('http')) return filePath;
    return environment.baseUrl + '/Files/' + filePath;
  }
}
